import React from "react";
import {Card, Text, Title3, makeStyles} from "@fluentui/react-components";
import {useTranslation} from "react-i18next";
import type {AdminAccessUxState} from "../../services/types.ts";
import {bodyKeyFor, titleKeyFor} from "../../utils/adminAccessCopy.ts";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        padding: "16px",
        maxWidth: "480px",
        margin: "0 auto",
    },
});

export interface AdminAccessBlockedMessageProps {
    accessState: Exclude<AdminAccessUxState, "admin" | "bootstrap_choice">;
    organizationName?: string;
}

export const AdminAccessBlockedMessage: React.FC<AdminAccessBlockedMessageProps> = ({
    accessState,
    organizationName,
}) => {
    const styles = useStyles();
    const {t} = useTranslation();
    const orgName = organizationName ?? t("text.your-organization");

    return (
        <Card>
            <div className={styles.container}>
                <Title3>{t(titleKeyFor(accessState))}</Title3>
                <Text>{t(bodyKeyFor(accessState), {organizationName: orgName})}</Text>
                {accessState === "subscription_inactive" && (
                    <Text>{t("text.subscription-inactive-hint")}</Text>
                )}
            </div>
        </Card>
    );
};

export default AdminAccessBlockedMessage;
